import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/material';
import { BRAND } from '../../configuration/theme';

/**
 * Buttons in CI blue. Hover and focus change colour rather than position, so
 * nothing shifts under the pointer.
 */

export const getPrimaryButtonStyles = (theme: Theme): SxProps => {
  const isDark = theme.palette.mode === 'dark';
  return {
    backgroundColor: isDark ? BRAND.light : BRAND.primary,
    color: isDark ? BRAND.anthracite : '#FFFFFF',
    px: 4,
    py: 1.5,
    borderRadius: 999,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: isDark ? '#C3CEE4' : BRAND.dark,
    },
  };
};

export const getSecondaryButtonStyles = (theme: Theme): SxProps => {
  const isDark = theme.palette.mode === 'dark';
  const line = isDark ? BRAND.light : BRAND.primary;
  return {
    backgroundColor: 'transparent',
    color: line,
    border: `1.5px solid ${line}`,
    px: 4,
    py: 1.5,
    borderRadius: 999,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: isDark ? 'rgba(167,183,214,0.14)' : 'rgba(93,116,171,0.1)',
      borderColor: line,
    },
  };
};

/** For use on a filled CI-blue section, where the page accent has no contrast. */
export const getOnBrandButtonStyles = (): SxProps => ({
  backgroundColor: '#FFFFFF',
  color: BRAND.primary,
  px: 4,
  py: 1.5,
  borderRadius: 999,
  fontWeight: 600,
  '&:hover': { backgroundColor: BRAND.offWhite },
});
